// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b19814b8","508":"a49cbb7f","530":"66d4b22c"}[chunkId] + ".chunk.js";
};